/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DashboardProductsReport_report = {
    readonly entity: string;
    readonly categories: {
        readonly airtime: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly data: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly entertainment: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly ticketing: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly billPayments: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly electricity: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
        readonly other: {
            readonly transactions: {
                readonly transactionCount: number;
                readonly transactionAmount: number;
            };
        } | null;
    };
    readonly " $refType": "DashboardProductsReport_report";
};
export type DashboardProductsReport_report$data = DashboardProductsReport_report;
export type DashboardProductsReport_report$key = {
    readonly " $data"?: DashboardProductsReport_report$data;
    readonly " $fragmentRefs": FragmentRefs<"DashboardProductsReport_report">;
};



const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "DetailedSalesReportTransActions",
    "kind": "LinkedField",
    "name": "transactions",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "transactionAmount",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DashboardProductsReport_report",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entity",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailedSalesReportCategories",
      "kind": "LinkedField",
      "name": "categories",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "airtime",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "data",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "entertainment",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "ticketing",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "billPayments",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "electricity",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailedSalesReportCategory",
          "kind": "LinkedField",
          "name": "other",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DetailedSalesReport",
  "abstractKey": null
};
})();
(node as any).hash = '7c00ad7a1a0d98907c14092e6dd516bc';
export default node;
